import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { GetLocationsFromServer } from './service-lane-dropdowns.actions';

import { ServiceLaneDropdownsPartialState } from './service-lane-dropdowns.reducer';
import { serviceLaneDropdownsQuery } from './service-lane-dropdowns.selectors';

@Injectable()
export class ServiceLaneDropdownsFacade {
  allDropdowns$ = this.store.pipe(select(serviceLaneDropdownsQuery.getAllDropdowns));
  serviceAppointmentDropdowns$ = this.store.pipe(select(serviceLaneDropdownsQuery.getServiceAppointmentDropdowns));
  serviceAppointmentCaseDropdowns$ = this.store.pipe(
    select(serviceLaneDropdownsQuery.getServiceAppointmentCaseDropdowns)
  );
  vehicleDropdowns$ = this.store.pipe(select(serviceLaneDropdownsQuery.getVehicleDropdowns));
  associateDropdowns$ = this.store.pipe(select(serviceLaneDropdownsQuery.getAssociateDropdowns));
  addressDropdowns$ = this.store.pipe(select(serviceLaneDropdownsQuery.getAddressDropdowns));
  locationsDropdowns$ = this.store.pipe(select(serviceLaneDropdownsQuery.locations));
  directMessageTemplatesDropdown$ = this.store.pipe(select(serviceLaneDropdownsQuery.directMessageTemplates));
  declinedReasonsDropdown$ = this.store.pipe(select(serviceLaneDropdownsQuery.declinedReasons));
  messageTypes$ = this.store.pipe(
    select(serviceLaneDropdownsQuery.messageTypes),
    map((messageTypes) => {
      return messageTypes.filter((mt) => mt.displayInXselleratorUIFlag == true);
    })
  );
  serviceAdvisors$ = this.store.pipe(select(serviceLaneDropdownsQuery.serviceAdvisors));

  getLocationsFromServer() {
    this.store.dispatch(new GetLocationsFromServer({ pageSize: 5000 }));
  }
  constructor(private store: Store<ServiceLaneDropdownsPartialState>) {}
}
